document.addEventListener('DOMContentLoaded', function () {
  function waitForElement(selector, callback, interval = 100) {
    const timer = setInterval(() => {
      const element = document.querySelector(selector);
      if (element) {
        clearInterval(timer);
        callback(element);
      }
    }, interval);
  }

  waitForElement('.yotpo-sr-bottom-line-summary', function (starWidget) {
    starWidget.addEventListener('click', function () {
      document.querySelectorAll('.product__accordion').forEach(function (accordion) {
        const yotpoReviews = accordion.querySelector('.yotpo-reviews-main-widget');
        const detailContainer = accordion.querySelector('details');
        if (yotpoReviews) {
          const summary = accordion.querySelector('summary');

          // Only open if not already open
          if (summary && !detailContainer.hasAttribute('open')) {
            summary.click();
          }

          // Always scroll to the accordion
          accordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  });
});
